import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { DateTime } from "luxon";
import CalendarIcon from "@material-ui/icons/Event";
import { anyNotBlank, notBlank } from "../common/general";
import { Grid } from "@material-ui/core";

const useStyles = marginTop =>
  makeStyles(theme => ({
    root: {
      marginTop: marginTop,
    },

    input: {
      marginTop: 16,
    },
  }));

const DatePicker = props => {
  const {
    xs,
    sm,
    md,
    onBlur,
    onChange,
    value,
    helperText,
    error,
    required = false,
    noLabel = false,
    label = "Publication Date",
    placeholder,
    disableToolbar = true,
    marginTop = 10,
  } = props;
  const classes = useStyles(marginTop)();

  const wrapGrid = element => {
    if (anyNotBlank([xs, sm, md])) {
      return (
        <Grid item xs={xs || 12} sm={sm || 6} md={md || 6}>
          {element}
        </Grid>
      );
    } else {
      return element;
    }
  };

  return wrapGrid(
    <KeyboardDatePicker
      className={classes.root}
      InputProps={
        noLabel
          ? {
              classes: { root: classes.input },
            }
          : {}
      }
      margin="none"
      disableToolbar={disableToolbar}
      fullWidth
      autoOk
      required={required}
      minDate={new Date("01/01/1000")}
      variant="inline"
      format="MM/dd/yyyy"
      id="date-picker-inline"
      label={noLabel ? null : label}
      placeholder={placeholder}
      value={notBlank(value) ? DateTime.fromISO(value).setZone("utc") : null}
      onChange={onChange}
      onBlur={onBlur}
      helperText={helperText}
      error={error}
      keyboardIcon={<CalendarIcon fontSize="small" />}
      KeyboardButtonProps={{
        "aria-label": "change date",
      }}
    />
  );
};

export default DatePicker;
